import { type FunctionList } from "@repo/common";
import { getFunctions, httpsCallable } from "firebase/functions";

const FUNCTIONS_REGION = "europe-west1";

export const typedHttpsCallable = async <TResult>({
  functionName,
  data,
}: {
  functionName: FunctionList;
  data: unknown;
}): Promise<TResult> => {
  const functions = getFunctions(undefined, FUNCTIONS_REGION);
  const callable = httpsCallable(functions, functionName);
  const result = await callable(data);

  return result.data as TResult;
};
